import { useState, useEffect } from "react";
import { Cookie } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const CONSENT_KEY = "fotbollsliv_cookie_consent";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY);
    if (!consent) {
      // Show banner after a short delay for better UX
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, "accepted");
    setVisible(false);
    // Re-enable GA tracking if it was paused
    if (window.gtag) {
      window.gtag("consent", "update", {
        analytics_storage: "granted",
      });
    }
  };

  const handleDecline = () => {
    localStorage.setItem(CONSENT_KEY, "declined");
    setVisible(false);
    // Disable GA tracking
    if (window.gtag) {
      window.gtag("consent", "update", {
        analytics_storage: "denied",
      });
    }
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6 bg-white border-t border-slate-200 shadow-lg"
      data-testid="cookie-consent-banner"
    >
      <div className="max-w-4xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <div className="flex items-start gap-3 flex-1">
            <div className="p-2 bg-[#FECC00]/10 rounded-lg hidden sm:block">
              <Cookie className="w-5 h-5 text-[#B8860B]" />
            </div>
            <div>
              <p className="text-sm text-slate-600 leading-relaxed">
                Vi använder cookies för att förbättra din upplevelse och analysera 
                trafiken på vår webbplats. Genom att klicka "Acceptera" godkänner 
                du användningen av cookies för analysändamål.
              </p>
              <Link
                to="/integritetspolicy"
                className="text-xs text-blue-600 hover:underline mt-1 inline-block"
              >
                Läs mer om vår integritetspolicy
              </Link>
            </div>
          </div>
          <div className="flex items-center gap-2 w-full sm:w-auto">
            <Button
              variant="outline"
              size="sm"
              onClick={handleDecline}
              className="flex-1 sm:flex-none text-sm"
              data-testid="cookie-decline-btn"
            >
              Avböj
            </Button>
            <Button
              size="sm"
              onClick={handleAccept}
              className="flex-1 sm:flex-none bg-[#0F172A] hover:bg-[#1e293b] text-white text-sm"
              data-testid="cookie-accept-btn"
            >
              Acceptera
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
